<template lang="pug">
.voiceless(:class="isStudyMode?'voiceless-study':''")
  j-table(:data="pageData.voiceless", :showTypes="showTypes", @j-cell-click="cellClickHandler")
  memory-study(v-if="showMemory", @write-board-close="hideMemory", :data="currentMemoryData")
</template>

<script>
import { defineComponent, reactive, ref } from 'vue';
import JTable from '@/components/JTable.vue';
import MemoryStudy from '@/components/MemoryStudy.vue';
import voiceless from '@/utils/voiceless';

export default defineComponent({
  name: 'Voiceless',
  components: {
    JTable,
    MemoryStudy,
  },
  props: {
    showTypes: Array,
    isStudyMode: Boolean,
  },
  setup() {
    console.log('voiceless==', voiceless);
    const showMemory = ref(false);
    const currentMemoryData = ref(null);
    const pageData = reactive({
      voiceless,
    });

    const cellClickHandler = (cellData) => {
      console.log('cellClickHandler==', cellData);
      // 禁止 body 滚动，否则与canvas手写时冲突
      document.body.classList.add('overflow-hidden');
      console.log('document.body.classList==', document.body.classList);
      currentMemoryData.value = cellData;
      showMemory.value = true;
      // eslint-disable-next-line
      window._rlog.push([
        '_trackCustom',
        'japanese50',
        [
          ['show', 'syllabary_practice'],
        ],
      ]);
    };
    const hideMemory = () => {
      document.body.classList.remove('overflow-hidden');
      showMemory.value = false;
    };

    return {
      pageData,
      showMemory,
      currentMemoryData,
      cellClickHandler,
      hideMemory,
    };
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .voiceless-study
    & >>> .j-table
      .row-value_table
        box-shadow: 0 0 0 2px #E1EBFF
        background rgba(225, 235, 255, 0.15)
      .row .row-value_table
        td.row-key_cell, td.row-value_cell
          border 1px solid rgba(225, 235, 255, 0.5)
</style>
<style lang="stylus" scoped>
  .dark
    .voiceless-study
      & >>> .j-table
        .row-value_table
          box-shadow: 0 0 0 2px #132440
          border 1px solid #132440
          background rgba(19, 36, 64, 0.15)
        .row .row-value_table
          td.row-key_cell, td.row-value_cell
            border 1px solid rgba(19, 36, 64, 0.5)
</style>
